import { h, Fragment } from 'preact';
import ProductGallery from '../product-gallery/product-gallery';
import ProductForm from '../product/product-form';
import { withProductContext } from '../product/product-context';

const ShopLookOverlayProduct = ({
  productState,
  productActions,
  handleClose,
}) => {
  const { currentVariant, currentProduct, products, options, relatedProducts } =
    productState;
  const { setCurrentProduct, setCurrentVariant, setOptions } = productActions;

  return (
    <>
      <div className="p-24 lc:py-32 md:py-32 border-b border-grey-400 last:border-none">
        <div className="relative">
          <ProductGallery
            isLookOverlay={true}
            currentProduct={currentProduct}
          />
          <ProductForm
            isLookOverlay={true}
            currentProduct={currentProduct}
            currentVariant={currentVariant}
            setCurrentVariant={setCurrentVariant}
            onAddToCart={handleClose}
            products={products}
            relatedProducts={relatedProducts}
            onProductChange={(item) => setCurrentProduct({ ...item })}
            options={options}
            setOptions={setOptions}
          />
        </div>
      </div>
    </>
  );
};

export default withProductContext(ShopLookOverlayProduct);
